import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobilePageHeader from '@/components/layout/MobilePageHeader';

const MissionsHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobilePageHeader 
      title="Missões" 
      onBack={() => navigate('/main/feed')} 
    />
  );
};

export default MissionsHeader;
